var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2188 20.1562C22.0312 20.1562 21.8906 20.0156 21.8906 19.875L5.53125 20.8594H5.48438V20.8125V0.609375C5.39062 0.5625 5.29688 0.46875 5.29688 0.328125C5.29688 0.140625 5.4375 0 5.625 0H22.2188C22.4062 0 22.5469 0.140625 22.5469 0.328125V19.8281C22.5469 20.0156 22.4062 20.1562 22.2188 20.1562Z",
    fill: "#F94848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45312 5.67188V3C1.45312 1.35938 2.8125 0 4.45312 0H5.625H5.67188H5.71875H5.76562V0.046875H5.8125V0.09375H5.85938V0.140625H5.90625V0.1875H5.95312V0.234375V0.28125V0.328125V19.8281C5.95312 20.0156 5.8125 20.1562 5.625 20.1562C5.53125 20.1562 5.4375 20.1094 5.39062 20.0625L2.10938 21.6094V21.75C2.10938 21.9375 1.96875 22.0781 1.78125 22.0781C1.59375 22.0781 1.45312 21.9375 1.45312 21.75V5.67188Z",
    fill: "#E04141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2188 24H3.75C2.48438 24 1.45312 22.9688 1.45312 21.75C1.45312 20.4844 2.48438 19.5 3.75 19.5H22.2188C22.4062 19.5 22.5469 19.6406 22.5469 19.8281V23.6719C22.5469 23.8594 22.4062 24 22.2188 24Z",
    fill: "#E04141"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0781 23.5312V19.9688H3.75C2.76562 19.9688 1.92188 20.7656 1.92188 21.75C1.92188 22.7344 2.76562 23.5312 3.75 23.5312H22.0781Z",
    fill: "#F0F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4844 17.5312C16.8281 17.5312 16.3594 17.0156 16.3594 16.4062V11.625C16.3594 11.4375 16.5 11.2969 16.6875 11.2969H18.3281C18.5156 11.2969 18.6562 11.4375 18.6562 11.625V16.4062C18.6562 17.0625 18.1406 17.5312 17.4844 17.5312Z",
    fill: "#35495E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5469 21.4219V22.0781H16.125C15.9375 22.0781 15.7969 21.9375 15.7969 21.75C15.7969 21.5625 15.9375 21.4219 16.125 21.4219H22.5469Z",
    fill: "#E04141"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3281 11.9531H15.9375C15.75 11.9531 15.6094 11.8125 15.6094 11.6719C15.375 9.09375 16.125 5.85938 17.5781 2.76562C17.625 2.625 17.7187 2.57812 17.8594 2.57812C18 2.57812 18.1406 2.67188 18.1875 2.8125C18.1875 2.90625 18.9375 5.29688 18.6562 11.625C18.6562 11.8125 18.5156 11.9531 18.3281 11.9531Z",
    fill: "#BDC3C7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3438 17.5312C10.5 17.5312 10.0312 16.125 10.0312 14.7656C10.0312 13.7812 10.125 12.7031 10.2188 11.5781C10.3125 10.5 10.3594 9.375 10.4062 8.25C10.4062 8.0625 10.5469 7.92188 10.7344 7.92188C13.2656 7.96875 9.51562 7.92188 12 7.92188C12.1875 7.92188 12.3281 8.0625 12.3281 8.25C12.3281 9.46875 12.4219 10.6406 12.5156 11.8125C12.5625 12.8438 12.6562 13.875 12.6562 14.7656C12.6562 16.0781 12.2344 17.5312 11.3438 17.5312Z",
    fill: "#E7A561"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3438 8.76562C10.125 8.76562 9.09375 7.35938 9.09375 5.67188C9.09375 3.98438 10.125 2.57812 11.3438 2.57812C11.9531 2.57812 12.5625 2.90625 12.9844 3.5625C13.3594 4.125 13.5938 4.875 13.5938 5.67188C13.5938 6.46875 13.3594 7.21875 12.9844 7.82812C12.5625 8.4375 11.9531 8.76562 11.3438 8.76562Z",
    fill: "#F0F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipe);
export default __webpack_public_path__ + "static/media/recipe.09331362a4573a7ea2a607825039c18c.svg";
export { ForwardRef as ReactComponent };